import { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { Router } from 'react-router'
import store, { StoreContext } from './stores'
import { createBrowserHistory } from 'history'
import { syncHistoryWithStore } from 'mobx-react-router'
import { QueryClient, QueryClientProvider } from 'react-query'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import ErrorBoundary from './Pages/ErrorPage/ErrorBoundary'
import hotjar from './hotjar'

const browserHistory = createBrowserHistory()
const queryClient = new QueryClient()

// Sentry Error Logging
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || ''
const SENTRY_TRACES_SAMPLE_RATE = parseFloat(
  process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '1'
)
const SENTRY_ENVIRONMENT =
  process.env.REACT_APP_SENTRY_ENVIRONMENT || 'undefined'
if (SENTRY_DSN !== '') {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
    environment: SENTRY_ENVIRONMENT
  })
}

// hotjar
hotjar.initialize()

// OTEL Logging
// ToDo

// Main App Render
ReactDOM.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <StoreContext.Provider value={store}>
        <Router
          history={syncHistoryWithStore(browserHistory, store.routingStore)}
        >
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </Router>
      </StoreContext.Provider>
    </QueryClientProvider>
  </StrictMode>,
  document.getElementById('root')
)
